const merchantUuidRegex = /^merchant_[0-9a-z]+$/;

export function isMerchantUuid(uuid: string): uuid is `merchant_${string}` {
  return merchantUuidRegex.test(uuid);
}
